module.exports = __webpack_public_path__ + "catalog/items/cube/cube.png";